export default "__VITE_ASSET__fjRAYG6K__"